export default __webpack_public_path__ + "static/media/step1-icon.581502b9.svg";